// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HivM","fullView":"styles_fullView__WsX-q"};